var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 355 255.1",
    "aria-labelledby": "youtubeIcon youtubeDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.5 48.6c-3.9-14.6-15.4-26-29.9-29.9-26.4-7.1-132.3-7.1-132.3-7.1S72.4 11.6 46 18.7C31.5 22.5 20 34 16.1 48.6 9 75 9 130.1 9 130.1s0 55.1 7.1 81.5c3.9 14.6 15.4 26 29.9 29.9 26.4 7.1 132.3 7.1 132.3 7.1s105.9 0 132.3-7.1c14.6-3.9 26-15.4 29.9-29.9 7.1-26.4 7.1-81.5 7.1-81.5s0-55.1-7.1-81.5zm-196 132.3V79.3l88 50.8-88 50.8z"
  })));
}

export default SvgIconSocialYoutube;